module.exports = __webpack_public_path__ + "img/videocloud.2ee71def.webp";